import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(
  (theme) => ({
    buttonsContainer: {
      flexDirection: 'row-reverse',
    },
  }),
  {index: 1},
);

export default useStyles;
